import type { StoryObj } from '@storybook/html'
import type { CobaltRadioButton as CobaltRadioButtonProps } from './cobalt-radio-button'

export default {
  title: 'Components/Form/cobalt-radio-button',
  argTypes: {
    label: {
      type: { name: 'string', required: true },
      description: 'This is the text which accompany the radio button. It is **required** for accessibility concerns.'
    },
    format: {
      control: 'select',
      options: ['right', 'left', 'hidden'],
      description: 'A string indicating the position of the label or if it is hidden.',
      table: {
        type: { summary: 'string' },
        defaultValue: { summary: 'right' }
      }
    },
    checked: {
      control: 'boolean',
      options: [true, false],
      description: 'A Boolean indicating whether the box is checked or unchecked. It should be false if the radio button is `indeterminate`.',
      table: {
        type: { summary: 'boolean' },
        defaultValue: { summary: false }
      }
    },
    disabled: {
      control: 'boolean',
      options: [true, false],
      description: 'A boolean indicating the disable state of the radio button. The `aria-disabled` attribute relies on this property.',
      table: {
        type: { summary: 'boolean' },
        defaultValue: { summary: false }
      }
    },
    cobaltRadioButtonChange: {
      description: 'Custom event emitted when radio button is checked or not',
      table: {
        type: {
          summary: 'Integration',
          detail:
            'React: onCobaltRadioButtonChange={handleChange}\nVue:@cobaltRadioButtonChange="handleChange"\nAngular:(cobaltRadioButtonChange)="handleChange()"\nVanillaJs:.addEventListener("cobaltRadioButtonChange", (event) => {//handle change});'
        }
      },

      action: 'cobaltRadioButtonChange'
    }
  }
}

const TemplateDefault = (args: CobaltRadioButtonProps) => {
  return `
<cobalt-radio-button label="${args.label}" format="${args.format}" checked="${args.checked}" disabled="${args.disabled}"></cobalt-radio-button>
  `
}

export const Default: StoryObj = TemplateDefault.bind({})

Default.args = {
  label: 'Label',
  format: 'right',
  checked: false,
  disabled: false
}

const TemplateDescription = (args: CobaltRadioButtonProps) => {
  return `
<cobalt-radio-button label="${args.label}" description="${args.description}"></cobalt-radio-button>
  `
}

export const WithDescription: StoryObj = TemplateDescription.bind({})

WithDescription.args = {
  label: 'Label',
  description: 'A description'
}

const TemplateOnChangeEvent = (args: CobaltRadioButtonProps) => {
  return `
<script>
  document.querySelector('#radio-button-on-change').addEventListener('cobaltRadioButtonChange', (e) => {
    document.querySelector('#radio-button-checked').textContent = e.detail
  })
</script>
<div style="display:flex; flex-direction: column; gap: var(--number-spacing-large);">
  <p class="typography-body-medium-regular">Radio button is checked: <span id="radio-button-checked">false</span></p>
  <cobalt-radio-button id="radio-button-on-change" label="${args.label}"></cobalt-radio-button>
</div>
`
}

export const OnChangeEvent: StoryObj = TemplateOnChangeEvent.bind({})

OnChangeEvent.args = {
  label: 'Label'
}
